<mh-alerts-wrapper>
  <section mhFilterBar>
    <div mhFilterGroup>
      <div>
        <mh-core-lib-datepicker
          [currentDates]="currentDates"
          [currentFilter]="currentFilterDate"
          (datepickerUpdated)="handleDatepickerUpdated($event)">
        </mh-core-lib-datepicker>
      </div>
      <mh-box-element *ngIf="fidelityPermisions.includes('interchain_followup_executive_result')">
        <mh-core-lib-filter-chain-zone [productId]="productId" [multipleSelectionMode]="true" (chainChanged)="setChain($event)"></mh-core-lib-filter-chain-zone>
      </mh-box-element>
      <mh-core-lib-filter-hotels [chainFilter]="originalChainFilter" [multipleSelectionMode]="true" (hotelsChanged)="setHotelsFilter($event)"></mh-core-lib-filter-hotels>
      <mh-core-lib-survey-wrapper *ngIf="chainFilter.length > 0" [productId]="productId" [chain]="chainFilter" [listenCustomerSubscribe]="false" [multipleSelectionMode]="true"
        (currentSurveySetted)="onSurveysLoaded()"
        #surveyWrapper></mh-core-lib-survey-wrapper>

      <div mhFilterGroup>
        <mh-index-selector 
          [translationPrefix]="'inter-chain.executive.table'"
          [actions]="filtersData['metrics']"
          [selectedOption]="filterSelected['metrics']"
          (optionSelected)="setSelectValue($event, 'metrics')">
        </mh-index-selector>
        
        <ng-container *ngIf="filterSelected['metrics'] === 'area' && filtersAreas.length > 0">
          <mh-index-selector 
            [translationPrefix]="'areas'"
            [actions]="filtersData['areas']"
            [selectedOption]="filterSelected['areas']"
            [valueType]="'number'"
            (optionSelected)="setSelectValue($event, 'areas')">
          </mh-index-selector>
        </ng-container>
      </div>
    </div>

  </section>

  <mh-box-element>
    <div class="tw-bg-white tw-h-[100%] tw-p-5 tw-rounded-lg tw-shadow-b-md tw-shadow-md tw-shadow-t-md tw-shadow-tb">
      <mh-chain-executive
        [currentDates]="currentDates"
        [productId]="productId"
        [metrics]="filters"
        [chain]="chainFilter"
        [filterSelected]="filterSelected"
        [filtersAreas]="filtersAreas"
        [surveysReady]="surveysReady"
        (areasAvailable)="onAreasAvailable($event)"
        (filterChangeNeeded)="onFilterChangeNeeded()"
        *ngIf="fidelityPermisions.includes('interchain_followup_executive_result')"></mh-chain-executive>
    </div>
  </mh-box-element>

</mh-alerts-wrapper>
